import { Vehicle } from '../../../types/vehicle';
import { v4 as uuid4 } from 'uuid';
import { Point } from '../../../context/context';

/**
 * Handles adding or editing a vehicle in the fleet.
 */
export function handleAddOrEditVehicle(
  vehicle: Vehicle,
  setVehicleModalOpen: (open: boolean) => void,
  setEditingVehicle: (vehicle: Vehicle | null) => void,
  setVehicleDraft: (vehicle: Vehicle | null) => void
) {
  setVehicleModalOpen(false);
  setEditingVehicle(null);
  setVehicleDraft(null);
}

/**
 * Handles editing a vehicle.
 */
export function handleEditVehicle(
  vehicle: Vehicle,
  setEditingVehicle: (vehicle: Vehicle | null) => void,
  setVehicleDraft: (vehicle: Vehicle | null) => void,
  setVehicleModalOpen: (open: boolean) => void
) {
  setEditingVehicle(vehicle);
  setVehicleDraft(vehicle);
  setVehicleModalOpen(true);
}

/**
 * Handles adding a new vehicle.
 */
export function handleAddVehicle(
  setEditingVehicle: (vehicle: Vehicle | null) => void,
  setVehicleDraft: (vehicle: Vehicle | null) => void,
  setVehicleModalOpen: (open: boolean) => void
) {
  setEditingVehicle(null);
  setVehicleDraft(null);
  setVehicleModalOpen(true);
}

/**
 * Handles picking the start location for a vehicle.
 */
export function handlePickStart(
  setPickMode: (mode: 'start' | 'end' | null) => void,
  setVehicleModalOpen: (open: boolean) => void,
  setVehicleDraft: (vehicle: Vehicle) => void,
  currentDraft?: Vehicle | null
) {
  if (currentDraft) {
    setVehicleDraft(currentDraft);
  }
  setPickMode('start');
  setVehicleModalOpen(false);
}

/**
 * Handles picking the end location for a vehicle.
 */
export function handlePickEnd(
  setPickMode: (mode: 'start' | 'end' | null) => void,
  setVehicleModalOpen: (open: boolean) => void,
  setVehicleDraft: (vehicle: Vehicle) => void,
  currentDraft?: Vehicle | null
) {
  if (currentDraft) {
    setVehicleDraft(currentDraft);
  }
  setPickMode('end');
  setVehicleModalOpen(false);
}

/**
 * Handles picking a point for a vehicle's start or end location.
 */
export function handlePointPick(
  point: Point,
  pickMode: 'start' | 'end' | null,
  vehicleDraft: Vehicle | null,
  editingVehicle: Vehicle | null,
  setVehicleDraft: (vehicle: Vehicle) => void,
  setPickMode: (mode: 'start' | 'end' | null) => void,
  setVehicleModalOpen: (open: boolean) => void
): boolean {
  if (!pickMode) return false;
  let draft: Vehicle;
  if (vehicleDraft) {
    draft = vehicleDraft;
  } else if (editingVehicle) {
    draft = editingVehicle;
  } else {
    draft = {
      id: uuid4(),
      name: '',
      standardSeats: 0,
      wheelchairSeats: 0,
      startLocation: '',
      endLocation: '',
      operatingHours: []
    };
  }
  if (pickMode === 'start') {
    setVehicleDraft({ ...draft, startLocation: point.id });
  } else if (pickMode === 'end') {
    setVehicleDraft({ ...draft, endLocation: point.id });
  }
  setPickMode(null);
  setVehicleModalOpen(true);
  return true;
} 
